import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
import { runBetAction } from '../../api/betActionSafety';
import { performGlobalLogout, logout, sessionExpired, login } from './authSlice';
/// post Bestslip

export const PostBestSlipfancy = createAsyncThunk(
    'match/PostBestSlipfancy',
    async (fancypayload, { rejectWithValue }) => {
        try {
            const response = await runBetAction(
                fancypayload?.userId,
                {
                    gameId:
                        fancypayload?.gameId ??
                        'CRICKET',

                    matchId:
                        fancypayload?.matchId,

                    roundId:
                        fancypayload?.roundId ??
                        fancypayload?.matchId,

                    marketType:
                        fancypayload?.marketType ??
                        null,

                    selection:
                        fancypayload?.selection ??
                        null,

                    betType:
                        fancypayload?.betType ??
                        null,

                    stake:
                        fancypayload?.stake ??
                        null,
                },
                () =>
                    api.post(
                        '/bets/place-fancy',
                        fancypayload
                    )
            );

            return response.data;
        } catch (err) {
            const errorData =
                err?.response?.data;

            return rejectWithValue(
                errorData &&
                typeof errorData === 'object'
                    ? errorData
                    : {
                        message:
                            err?.message ||
                            'Failed to place bet',

                        status:
                            err?.betSafetyStatus ||
                            err?.code ||
                            'unknown',

                        betStatusUnknown:
                            err?.betStatusUnknown === true,

                        attemptId:
                            err?.attemptId ||
                            null,
                    }
            );
        }
    }
);

export const PostBestSlip = createAsyncThunk(
    'match/PostBestSlip',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await runBetAction(
                payload?.userId,
                {
                    gameId:
                        payload?.gameId ??
                        'CRICKET',

                    matchId:
                        payload?.matchId,

                    roundId:
                        payload?.roundId ??
                        payload?.matchId,

                    marketType:
                        payload?.marketType ??
                        null,

                    selection:
                        payload?.selection ??
                        null,

                    betType:
                        payload?.betType ??
                        null,

                    stake:
                        payload?.stake ??
                        null,
                },
                () =>
                    api.post(
                        '/bets/place',
                        payload
                    )
            );

            return response.data;
        } catch (err) {
            const errorData =
                err?.response?.data;

            return rejectWithValue(
                errorData &&
                typeof errorData === 'object'
                    ? errorData
                    : {
                        message:
                            err?.message ||
                            'Failed to place bet',

                        status:
                            err?.betSafetyStatus ||
                            err?.code ||
                            'unknown',

                        betStatusUnknown:
                            err?.betStatusUnknown === true,

                        attemptId:
                            err?.attemptId ||
                            null,
                    }
            );
        }
    }
);
export const getUserBets = createAsyncThunk(
  'match/getUserBets',
  async ({ userId, matchId }, { rejectWithValue }) => {
    if (!userId) {
      return rejectWithValue({ message: 'User ID is required' });
    }

    try {
      const response = await api.get('/bets/user-bets', {
        params: { userId, matchId }   
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch user bets' }
      );
    }
  }
);

export const getfancyUserBets = createAsyncThunk(
  'match/getfancyUserBets',
  async ({ userId, matchId }, { rejectWithValue }) => {
    if (!userId) {
      return rejectWithValue({ message: 'User ID is required' });
    }

    try {
      const response = await api.get('/bets/user-bets/fancy', {
        params: { userId, matchId }   
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch user bets' }
      );
    }
  }
);

export const getmaxsession = createAsyncThunk(
  'match/getmaxsession',
  async (matchId, { rejectWithValue }) => {
    if (!matchId) {
      return rejectWithValue({ message: 'matchId ID is required' });
    }

    try {
      const response = await api.get(`/limits/session/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);

export const getmaxlimits = createAsyncThunk(
  'match/getmaxlimits',
  async (matchId, { rejectWithValue }) => {
    if (!matchId) {
      return rejectWithValue({ message: 'matchId ID is required' });
    }

    try {
      const response = await api.get(`/limits/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max limits' }
      );
    }
  }
);


export const AccountStatementdepositewid = createAsyncThunk(
  'match/AccountStatementdepositewid',
  async (userId, { rejectWithValue }) => {
    if (!userId) {
      return rejectWithValue({ message: 'userId is required' });
    }

    try {
      const response = await api.get(`/account-statement/deposit-withdraw/${userId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
)

export const AccountStatemetsportfilter = createAsyncThunk(
    'match/AccountStatemetsportfilter',
    async ({ userId, sports }, { rejectWithValue }) => {  
        if (!userId) {
            return rejectWithValue({ message: 'userId is required' });
        }
        if (!sports) {
            return rejectWithValue({ message: 'sports name is required' });
        }

        try {
            const response = await api.get(`/account-statement/${sports}/${userId}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message
                    ? { message: err.response.data.message }
                    : { message: 'Failed to fetch sport account statement' }
            );
        }
    }
);

/// bet slip max button api 
export const limitmaxbutton = createAsyncThunk(
  'match/limitmaxbutton',
  async ({ matchId, marketType }, { rejectWithValue }) => {
    if (!matchId || !marketType) {
      return rejectWithValue({ message: 'userId and marketType are required' });
    }

    try {
      const response = await api.get(`/limits/match/${matchId}/${marketType}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);


export const limitdata = createAsyncThunk(
  'match/limitdata',
  async ( matchId , { rejectWithValue }) => {

    try {
      const response = await api.get(`/limits/match/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);




export const getwintosshide = createAsyncThunk(
  'match/getwintosshide',
  async (matchId, { rejectWithValue }) => {
    if (!matchId) {
      return rejectWithValue({ message: 'userId and marketType are required' });
    }
    try {
      const response = await api.get(`/sports/toss/${matchId}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);



export const getrunamout = createAsyncThunk(
  'match/getrunamout',
  async ({ userId, matchId, selection }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/bets/session-book`, {
        userId,
        matchId,
        selection,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message
          ? { message: err.response.data.message }
          : { message: 'Failed to fetch max session' }
      );
    }
  }
);



const resetRunAmountState = (state) => {
  state.getrunamoutData = [];
  state.runAmountUserId = null;
  state.runAmountRequestId = null;
  state.runAmountLoading = false;
  state.runAmountError = null;
};

const matchSlice = createSlice({
  name: 'match',
  initialState: {
    data: [],
    getuserbetsdata:[],
    getfancybetsdata:[],
    depositewidData:[],
    sportfilterData:[],
    limitdata:[],
    getrunamoutData:[],
    runAmountUserId: null,
    runAmountRequestId: null,
    limitmaxbuttonData:[],
    getwintosshideData:[],
    editLimit:{},
    maxlimit:[],
    maxsession:[],
    loading: false,
    error: null,
    runAmountLoading: false,
    runAmountError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      ////  post  btesslip
      .addCase(PostBestSlip.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(PostBestSlip.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload ?? [];
      })
      .addCase(PostBestSlip.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
      })


         ////  post fancy   btesslip
      .addCase(PostBestSlipfancy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(PostBestSlipfancy.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload ?? [];
      })
      .addCase(PostBestSlipfancy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
      })
      ///// get matxh bets uswer
      .addCase(getUserBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserBets.fulfilled, (state, action) => {
        state.loading = false;
        state.getuserbetsdata = action.payload || [];
      })
      .addCase(getUserBets.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ||
          action.error?.message ||
          'Something went wrong';
      })

       ///// fancy get matxh bets uswer
      .addCase(getfancyUserBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getfancyUserBets.fulfilled, (state, action) => {
        state.loading = false;
        state.getfancybetsdata = action.payload || [];
      })
      .addCase(getfancyUserBets.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ||
          action.error?.message ||
          'Something went wrong';
      })


      ///// get max session/////
      .addCase(getmaxsession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getmaxsession.fulfilled, (state, action) => {
        state.loading = false;
        state.maxsession = action.payload || [];
      })
      .addCase(getmaxsession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

       ///// get max Limit////
      .addCase(getmaxlimits.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getmaxlimits.fulfilled, (state, action) => {
        state.loading = false;
        state.maxlimit = action.payload || [];
      })
      .addCase(getmaxlimits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })
             ///// AccountStatementdepositewid////
      .addCase(AccountStatementdepositewid.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AccountStatementdepositewid.fulfilled, (state, action) => {
        state.loading = false;
        state.depositewidData = action.payload || [];
      })
      .addCase(AccountStatementdepositewid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

            ///// AccountStatementspoerts filter////
       .addCase(AccountStatemetsportfilter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AccountStatemetsportfilter.fulfilled, (state, action) => {
        state.loading = false;
        state.sportfilterData = action.payload || [];
      })
      .addCase(AccountStatemetsportfilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

            /////  bet slip max buttonn ////
       .addCase(limitmaxbutton.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(limitmaxbutton.fulfilled, (state, action) => {
        state.loading = false;
        state.limitmaxbuttonData = action.payload || [];
      })
      .addCase(limitmaxbutton.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message ||action.error?.message ||'Something went wrong';
      })

      /////  Hide win the toss  manually ////
     .addCase(getwintosshide.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getwintosshide.fulfilled, (state, action) => {
            state.loading = false;
            state.getwintosshideData = Array.isArray(action.payload) 
                ? action.payload 
                : [action.payload].filter(Boolean);  
        })
        .addCase(getwintosshide.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || action.error?.message || 'Something went wrong';
           
        })

        /////  limit data////
     .addCase(limitdata.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(limitdata.fulfilled, (state, action) => {
            state.loading = false;
           state.limitdata = action.payload || [];
        })
        .addCase(limitdata.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.message || action.error?.message || 'Something went wrong';
           
        })

        .addCase(getrunamout.pending, (state, action) => {
            state.runAmountUserId = action.meta.arg?.userId || null;
            state.runAmountRequestId = action.meta.requestId;
            state.runAmountLoading = true;
            state.runAmountError = null;
        })
        .addCase(getrunamout.fulfilled, (state, action) => {
            if (state.runAmountRequestId !== action.meta.requestId) {
                return;
            }

            state.runAmountLoading = false;
            state.runAmountRequestId = null;
            state.getrunamoutData = action.payload || [];
        })
        .addCase(getrunamout.rejected, (state, action) => {
            if (state.runAmountRequestId !== action.meta.requestId) {
                return;
            }

            state.runAmountLoading = false;
            state.runAmountRequestId = null;
            state.runAmountError = action.payload?.message || action.error?.message || 'Something went wrong';
        })

        .addCase(login.pending, (state) => {
            resetRunAmountState(state);
        })
        .addCase(login.fulfilled, (state) => {
            resetRunAmountState(state);
        })
        .addCase(logout, (state) => {
            resetRunAmountState(state);
        })
        .addCase(sessionExpired, (state) => {
            resetRunAmountState(state);
        })

        // GLOBAL LOGOUT
        .addCase(performGlobalLogout.fulfilled, (state) => {
            state.data = [];
            state.getuserbetsdata = [];
            state.getfancybetsdata = [];
            state.depositewidData = [];
            state.sportfilterData = [];
            state.limitdata = [];
            state.limitmaxbuttonData = [];
            state.getwintosshideData = [];
            state.editLimit = {};
            state.maxlimit = [];
            state.maxsession = [];
            state.loading = false;
            state.error = null;
            resetRunAmountState(state);
        });
  },
});

export default matchSlice.reducer;